import { Typography } from '@breetometer/components';
import { AnimatedLoaderIcon } from 'BreetAssets';

import type { ITooltipContent } from './Tooltip.helpers';

export const TooltipContent = ({ content, linkTitle, linkUrl, onLinkClick, loading }: ITooltipContent) => (
	<div className='tooltipcontent'>
		<Typography
			as='span'
			className='tooltipcontent_tip color-neutral-50'
		>
			{content}
			{!!linkTitle && (
				<>
					&nbsp;&nbsp;
					<Typography
						as='a'
						to={{ pathname: linkUrl }}
						onClick={onLinkClick}
						className='tooltipcontent_cta color-tertiary-400'
					>
						{linkTitle}
					</Typography>
					{loading && (
						<>
							&nbsp;
							<AnimatedLoaderIcon className='svg-dark tooltipcontent_loader' />
						</>
					)}
				</>
			)}
		</Typography>
	</div>
);
